import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class LocaleStringsListItemTranslate extends Component {
  state = {
    value: this.props.string.props.value ? this.props.string.props.value : '',
    isDirty: false
  }

  constructor (props) {
    super(props);

    this.onTextUpdate = this.onTextUpdate.bind(this);
  }

  onTextUpdate (e) {
    const value = e.target.value;

    this.props.string.props.value = value;
    this.props.string.props.isDirty = (this.props.originalValue !== value);

    this.setState({
      value: value,
      isDirty: this.props.string.props.isDirty
    });

    this.props.changesBeacon();
  }

  componentWillReceiveProps (newProps) {
    if (newProps.originalValue !== this.props.originalValue && this.state.isDirty) {
      this.setState({ isDirty: false });
    }
  }

  getStringStatus () {
    if (this.props.isSaving) {
      return {
        class: 'is-loading'
      }
    }

    if (this.state.isDirty) {
      return {
        text: 'edited',
        class: 'is-dirty'
      };
    }

    if (this.props.string.props.state === 'rejected') {
      return {
        text: 'rejected',
        class: 'rejected'
      };
    }

    if (this.props.string.props.state === 'validated') {
      return {
        text: 'validated',
        class: 'validated'
      };
    }

    return {
      class: null,
      text: null
    };
  }

  render () {
    let status = this.getStringStatus();

    let infoBalloon = null;
    if (this.props.string.props.description) {
      infoBalloon = (
        <span data-balloon={this.props.string.props.description} data-balloon-pos="up">
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="square" color="#019294" />
            <FontAwesomeIcon icon="question" color="white" transform="shrink-8" />
          </span>
        </span>
      );
    } else {
      infoBalloon = (
        <span data-balloon={this.props.string.props.description} data-balloon-pos="up">
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon="square" color="#c1baba" />
            <FontAwesomeIcon icon="question" color="white" transform="shrink-8" />
          </span>
        </span>
      );
    }

    return (
      <tr className={status.class}>
        <td className="game-context" title={this.props.string.props.context}>{this.props.string.props.context}</td>
        <td className="master" title={this.props.string.props.master}>{this.props.string.props.master}</td>
        <td className="master-help">
          {infoBalloon}
        </td>
        <td>
          <input 
            onKeyUp={this.onTextUpdate} 
            className="locale.strings.item is-primary input" 
            defaultValue={this.state.value}
            disabled={this.props.readonly}
          />
        </td>
        <td className="help-message" title={status.text}>
          {status.text}
        </td>
      </tr>
    );
  }
}

export default LocaleStringsListItemTranslate;


// WEBPACK FOOTER //
// ./src/Components/LocaleStrings/LocaleStringsListItemTranslate.js